import React, { useContext } from "react"
import styled from "styled-components"
import { Link } from "gatsby"

import colors from "../utils/colors"
import LocaleContext from "../context/localeContext"

import Icon from "./Icon"
interface LogoProps extends IsInvertedProps {
  children: string | JSX.Element | JSX.Element[]
}

interface DefaultLogoProps extends IsInvertedProps {
  isSmall?: boolean
}

interface IsInvertedProps {
  isInverted?: boolean
}
interface ProLogoProps extends IsInvertedProps {
  isPro?: boolean
}
const LinkContainer = styled.div<IsInvertedProps>`
  > a {
    color: ${props => (props.isInverted ? colors.white : colors.black)};
  }
`

export const HmdConnectLogo = ({ isInverted, isSmall }: DefaultLogoProps) => {
  const locale = useContext(LocaleContext)
  return (
    <LinkContainer isInverted={isInverted}>
      <Link to={`/${locale !== "en" ? locale : ""}`} data-gtm-cta="navigation-logo">
        <Icon icon="hmd-connect" width="158px" height="20" />
      </Link>
    </LinkContainer>
  )
}

export const HmdGlobalLogo = () => {
  return (
    <LinkContainer>
      <a href="https://www.hmdglobal.com/about" target="_blank" data-gtm-cta="hmd-global-logo">
        <Icon icon="hmd-global" />
      </a>
    </LinkContainer>
  )
}

export const HmdConnectProLogo = ({ isPro }: ProLogoProps) => {
  const locale = useContext(LocaleContext)

  return (
    <LinkContainer className="hmdConnectPro-logo" isInverted={!isPro}>
      <Link to={"/"} data-gtm-cta="hmd-connect-pro-logo">
        <Icon icon="hmd-connect-pro" />
      </Link>
    </LinkContainer>
  )
}
